/** baby: Public NINK links for landing nav, CTAs, and docs cross-links */
export const NINK_GITHUB_URL = 'https://github.com/ninworks/nink'
/** baby: Soft/secondary: primary installers ship via Vercel Blob + /api/nink/download */
export const NINK_RELEASES_URL = 'https://github.com/ninworks/nink/releases'
export const NINK_DOCS_URL = '/docs/open-source/nink'
export const NINK_DOWNLOAD_HREF = '/nink#download'
